import { render, staticRenderFns } from "./AddMonitor.vue?vue&type=template&id=967f8012&"
import script from "./AddMonitor.vue?vue&type=script&lang=js&"
export * from "./AddMonitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports